import React, { useEffect, createElement } from 'react';
import { HeroSection } from './components/HeroSection';
import { PainPoints } from './components/PainPoints';
import { Features } from './components/Features';
import { Bonuses } from './components/Bonuses';
import { OfferStack } from './components/OfferStack';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';

// 👇 NUEVO COMPONENTE: Botón Flotante de WhatsApp (Estilo Masterkit IA)
function WhatsAppFloatingButton() {
  const phoneNumber = "584123555747";
  const message = encodeURIComponent("¡Hola! Tengo una duda sobre el Toolkit Digital Pro 🚀");
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${message}`;
  return <a href={whatsappUrl} target="_blank" rel="noopener noreferrer" className="fixed bottom-6 right-6 z-[9999] group" data-id="element-0">
      {/* Tooltip (Mensaje que aparece al pasar el mouse) */}
      <span className="absolute right-16 top-1/2 -translate-y-1/2 bg-white text-black text-sm font-bold py-2 px-4 rounded-lg opacity-0 group-hover:opacity-100 transition-opacity duration-300 shadow-xl whitespace-nowrap pointer-events-none border border-gray-200" data-id="element-1">
        ¿Dudas? Escríbeme aquí 👋
      </span>

      {/* Círculo con efecto de pulso verde intermitente */}
      <div className="relative flex items-center justify-center w-14 h-14 md:w-16 md:h-16 bg-[#25D366] rounded-full shadow-[0_0_20px_rgba(37,211,102,0.4)] hover:scale-110 transition-transform duration-300" data-id="element-2">
        {/* Anillo de animación ping */}
        <div className="absolute inset-0 bg-[#25D366] rounded-full animate-ping opacity-25" data-id="element-3"></div>
        
        {/* Ícono de WhatsApp nativo */}
        <svg viewBox="0 0 32 32" className="w-7 h-7 md:w-8 md:h-8 text-white relative z-10" xmlns="http://www.w3.org/2000/svg" data-id="element-4">
          <path d="M16.002 2.186c-7.615 0-13.791 6.175-13.791 13.791 0 2.433.633 4.811 1.834 6.895l-1.956 7.143 7.309-1.917c2.046 1.096 4.35 1.674 6.605 1.674 7.612 0 13.788-6.175 13.788-13.791 0-7.615-6.176-13.795-13.789-13.795zm0 25.143c-2.062 0-4.088-.553-5.857-1.602l-.42-.249-4.355 1.142 1.161-4.246-.273-.435c-1.153-1.834-1.761-3.953-1.761-6.143 0-6.309 5.132-11.442 11.443-11.442s11.44 5.133 11.44 11.442c-.001 6.31-5.133 11.442-11.442 11.442zm6.276-8.561c-.344-.173-2.035-1.005-2.351-1.12-.315-.115-.545-.173-.775.173-.229.345-.888 1.12-1.089 1.35-.201.229-.402.258-.745.086-2.147-.946-3.69-2.095-5.123-4.577-.184-.319.18-.302.516-.973.086-.173.043-.328-.043-.501-.086-.173-.775-1.868-1.062-2.558-.279-.672-.562-.581-.775-.592-.2-.009-.43-.009-.659-.009-.229 0-.602.086-.918.432-.315.345-1.205 1.178-1.205 2.872 0 1.693 1.233 3.328 1.405 3.558.173.229 2.425 3.7 5.874 5.19 2.508 1.083 3.42.923 4.022.836.699-.101 2.035-.833 2.322-1.638.286-.805.286-1.495.201-1.638-.087-.146-.317-.233-.66-.406z" fill="currentColor" data-id="element-5"></path>
        </svg>
      </div>
    </a>;
}
export function App() {
  useEffect(() => {
    // Meta Pixel initialization
    ;
    (function (f: any, b: any, e: any, v: any, n?: any, t?: any, s?: any) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = true;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s);
      } else {
        b.head.appendChild(t);
      }
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    (window as any).fbq('init', '951909037158376');
    (window as any).fbq('track', 'PageView');
  }, []);
  return (
    // 👉 overflow-x-hidden evita el desplazamiento lateral negro en móviles
    <div className="min-h-screen bg-[#050505] font-sans text-white selection:bg-cyan-500/30 overflow-x-hidden w-full relative" data-id="element-6">
      <main className="w-full" data-id="element-7">
        <HeroSection data-id="element-8" />
        <PainPoints data-id="element-9" />
        <Features data-id="element-10" />
        <Bonuses data-id="element-11" />
        <OfferStack data-id="element-12" />
        <Testimonials data-id="element-13" />
        <FAQ data-id="element-14" />
      </main>
      
      <FinalCTA data-id="element-15" />

      {/* Aquí llamamos al nuevo botón flotante */}
      <WhatsAppFloatingButton data-id="element-16" />
    </div>
  );
}